import React from 'react';
import { ShieldCheckIcon, CreditCardIcon, MailIcon } from 'lucide-react';
export function FinalCTA() {
  return <section className="w-full bg-transparent py-8" data-id="element-57">
      <div className="max-w-6xl mx-auto px-4 md:px-6" data-id="element-58">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-6 text-center" data-id="element-59">
          Elegí tu MegaPack ahora
        </h2>
        <div className="flex flex-wrap justify-center items-center gap-6 mb-5" data-id="element-60">
          <div className="flex items-center gap-2 text-gray-400" data-id="element-61">
            <ShieldCheckIcon className="w-6 h-6 text-[#C084FC]" data-id="element-62" />
            <span data-id="element-63">Pago 100% seguro</span>
          </div>
          <div className="flex items-center gap-2 text-gray-400" data-id="element-64">
            <CreditCardIcon className="w-6 h-6 text-[#C084FC]" data-id="element-65" />
            <span data-id="element-66">Mercado Pago · Tarjeta · Transferencia</span>
          </div>
        </div>
      </div>
    </section>;
}